import 'twin.macro'
import 'react-loading-skeleton/dist/skeleton.css'

import Sign from 'assets/icons/exclamation-triangle.svg?component'
import Button from 'components/UI/Buttons/Button'
import Typography from 'components/UI/Typography'
import Heading from 'components/UI/Typography/Heading'
import Wrapper from 'components/UI/Wrapper'
import { useAppSelector } from 'hooks'
import useLogout from 'hooks/useLogout'
import { Fragment, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import Skeleton from 'react-loading-skeleton'
import { useGetApplicationStatusQuery } from 'redux/api'
import { getStatusSelector } from 'redux/store/slices/statusSlice'
import { getCurrentFlowId } from 'redux/store/slices/userSlice'
import tw from 'twin.macro'
import { getDearUserText, removeExtraWhitespace } from 'utils'

const Rejected = () => {
  // Tools
  const {
    t,
    i18n: { language }
  } = useTranslation()

  // State
  const [isTimerDone, setIsTimerDone] = useState(false)

  // Selectors
  const currentFlowId = useAppSelector(getCurrentFlowId)
  const statusData = useAppSelector(getStatusSelector)

  // Queries
  const {
    isLoading: isStatusLoading,
    isFetching,
    data
  } = useGetApplicationStatusQuery(currentFlowId as string, {
    refetchOnMountOrArgChange: true,
    skip: !isTimerDone
  })

  // Custom hooks
  const logout = useLogout()

  // Computed values
  const userName = getDearUserText({
    gender: data?.borrower_record.gender,
    first_name: data?.borrower_record.first_name,
    middle_name: data?.borrower_record.middle_name
  })

  // Effects
  useEffect(() => {
    const id = setTimeout(() => {
      setIsTimerDone(true)
    }, 1400)

    return () => {
      clearTimeout(id)
    }
  }, [])

  return (
    <Wrapper twStyle={tw`min-h-[calc(100vh - 84px)] flex flex-col justify-center`}>
      {!isTimerDone || isStatusLoading || isFetching ? (
        <div>
          <div tw='text-center flex-1'>
            <Skeleton tw='h-36 w-36' circle />
            <Skeleton width='80%' tw='h-8 mt-10' />
            <Skeleton width='100%' tw='mt-6 h-6' />
            <Skeleton width='80%' tw='mt-1 h-6' />
            <Skeleton width={470} height={60} tw='mt-10' />
          </div>
        </div>
      ) : (
        <Fragment>
          <div tw='bg-secondary mb-10 p-5 rounded-[100px] inline-flex mx-auto'>
            <Sign tw='h-24 w-24' />
          </div>
          <Heading twStyle={tw`text-center `}>{removeExtraWhitespace(userName)}</Heading>
          <Typography text twStyle={tw`text-center mt-3`}>
            {language === 'ru'
              ? data?.current_step?.status_reason ?? statusData.current_step?.status_reason
              : data?.current_step?.status_reason_kk ?? statusData.current_step?.status_reason_kk}
          </Typography>
          <Button
            twStyle={tw`border-[1px] border-grey-middle rounded-[20px] mt-10 max-w-[470px] shadow-none mx-auto`}
            onClick={logout}
          >
            <Typography weight='bold'>{t('flow-back-to-main')}</Typography>
          </Button>
        </Fragment>
      )}
    </Wrapper>
  )
}

export default Rejected
